exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-content[data-v-30194dbe] a{color:#2bc275!important;text-decoration:underline;font-weight:700}.nav-banner-message-container[data-v-30194dbe]{min-height:50px;color:var(--breadcrumb-text)}.nav-banner-message-wrapper[data-v-30194dbe]{color:var(--breadcrumb-text);padding-bottom:10px}", ""]);

// exports
